import styled from 'styled-components'
import { BLACK, VIOLET_600, WHITE } from '../../styles/colors'
import { GIVONIC, INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ContentContainer = (styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding-bottom: 100px;
  padding-top: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const IconWrapper = (styled.div<{ $margin: number }>`
  margin: ${({ $margin }) => $margin}px;
  margin-top: 0;
  margin-bottom: 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const TitleContainer = (styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Title = (styled.span`
  font-family: ${GIVONIC.bold};
  font-size: 20px;
  color: ${VIOLET_600};
  text-align: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const Description = (styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  line-height: 22px;
  color: ${BLACK};
  text-align: center;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const ButtonContainer = (styled.div<{ $safeAreaBottom: number }>`
  position: absolute;
  bottom: 0;
  padding: 0 12px 16px 12px;
  background-color: ${WHITE};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ $safeAreaBottom }) => $safeAreaBottom || 16}px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
